import Vue from "vue";
import Router from "vue-router";

import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import BilingualNews from "@/views/BilingualNews.vue";
import AboutUs from "@/views/AboutUs.vue";
import NewsDetail from "@/views/NewsDetail.vue";
import BrandActivity from "@/views/BrandActivity.vue";
import Search from "@/views/Search.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "Home",
      meta: {
        title: '国际品牌网',
      },
      component: Home,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/bilingual-news",
      name: "BilingualNews",
      component: BilingualNews,
    },
    {
      path: "/about-us",
      name: "AboutUs",
      component: AboutUs,
    },
    {
      path: "/news-detail/:id",
      name: "NewsDetail",
      meta: {
        title: '国际品牌网',
      },
      component: NewsDetail,
    },
    {
      path: "/brand-activity",
      name: "BrandActivity",
      component: BrandActivity,
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
    },
  ],
});
